export const EPHEMERAL_EMPLACEMENT_STORE = 'selectionPatrimoineEmplacements';

export const EPHEMERAL_DISPOSITIF_STORE = 'selectionPatrimoineDispositifs';

export const EPHEMERAL_MATERIEL_STORE = 'selectionPatrimoineMateriels';

export const EPHEMERAL_FACE_STORE = 'selectionPatrimoineFaces';

export const SELECTION_STATE = {
  SELECTED: 'selected',
  UNSELECTED: 'unselected',
  SELECTED_PARTIALLY: 'selectedPartially',
};
